import { useState, FormEvent } from "react";
import { Users, X } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Staff } from "./types";

export default function TeamDialog({ staff, onAdded }: { staff: Staff[]; onAdded: () => void }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", email: "", password: "", role: "sales" });

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      await api.post("/staff", f);
      toast.success(`${f.name} added`);
      setF({ name: "", email: "", password: "", role: "sales" });
      onAdded();
    } catch (err) {
      toast.error(apiError(err));
    }
  };

  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="crm-team-button" className="flex items-center gap-1 rounded-sm border border-slate-700 px-2.5 py-1.5 text-xs text-slate-300 hover:border-brand-500 hover:text-brand-400">
        <Users className="h-3.5 w-3.5" /> Team
      </button>
      {open && (
        <div className="fixed inset-0 z-50 grid place-items-center bg-black/70 p-4" onClick={() => setOpen(false)}>
          <div className="w-full max-w-md border border-slate-700 bg-[#161920] p-6" onClick={(e) => e.stopPropagation()} data-testid="team-dialog">
            <div className="mb-4 flex items-center justify-between">
              <h2 className="text-xl font-bold uppercase text-white">Sales team</h2>
              <button onClick={() => setOpen(false)} data-testid="team-dialog-close"><X className="h-5 w-5 text-slate-400" /></button>
            </div>
            <ul className="mb-6 divide-y divide-slate-800 text-sm">
              {staff.map((s) => (
                <li key={s.id} className="flex justify-between py-2"><span className="text-white">{s.name}</span><span className="text-slate-500">{s.email} · {s.role}</span></li>
              ))}
            </ul>
            <form onSubmit={submit} className="grid gap-2">
              <input className="crm-field" placeholder="Name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="team-name-input" />
              <input className="crm-field" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="team-email-input" />
              <input className="crm-field" type="password" placeholder="Temporary password (8+ chars)" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="team-password-input" />
              <select className="crm-field" value={f.role} onChange={(e) => setF({ ...f, role: e.target.value })} data-testid="team-role-select">
                <option value="sales">Sales</option>
                <option value="admin">Admin</option>
              </select>
              <button className="btn-brand !min-h-0 !py-2 !text-base" data-testid="team-add-button">Add staff member</button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
